import { SearchIcon, SearchIcon2 } from 'shared/icons'
import styles from './LocationButton.module.css'
import React, { useMemo } from 'react'
import classNames from 'classnames'
import { BreakPointsWidth } from 'shared/enums/BreakPointsWidth'
import { Breakpoint } from 'shared/types/Breakpoint'
import { DEFAULT_BREAKPOINTS } from 'shared/constants/breakpointsWidth'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { filtersToString } from 'shared/lib/filtersToString'
import { spyLaunchSettingsToString } from 'shared/lib/spyLaunchSettingsToString'

interface Value{
    'id': number,
    'name': string,
    'googlePlaceId': string
}

interface LocationButtonProps {
    active: boolean
    caption: string
    className?: string
    ref?: any
    location?: Value
    filters?: any
    spyLaunchSettings?: any
    onClick?: (event: any) => void
}

export const LocationButton = (props: LocationButtonProps): JSX.Element => {
    const {
        active = false,
        className,
        ref,
        caption,
        location = undefined,
        filters,
        spyLaunchSettings,
        onClick,
    } = props

    const breakpointUpXl = useBreakpointUp('xl')

    const searchButtonClasses = classNames(styles.SearchButton, className, {
        [styles[`SearchButton--Active`]]: active,
        [styles[`SearchButton--HasValue`]]: location !== undefined
    })

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    const hasValue = location!== undefined
    const heading = useMemo(() => {
        if (hasValue){
            return `Location`
        }

        return 'Select Location'
    }, [
        location
    ])

    if (breakpointUpXl === true) {
        return (
            <button
                ref={ref}
                className={searchButtonClasses}
                onClick={handleButtonClick}
            >
                <span className={styles.LocationButton__HelperContainer}>
                    <span className={styles.SearchButton__IconContainer}>
                        <SearchIcon2
                            className={styles.SearchButton__Icon}
                        />
                    </span>
                    <span className={styles.SearchButton__CaptionContainer}>
                        <span className={styles.SearchButton__Caption}>{heading}</span>
                    </span>
                </span>

                <span className={styles.LocationButton__ValueContainer}>
                    <span className={styles.LocationButton__ValueCaption}>
                        {location?.name}
                    </span>
                </span>
            </button>
        )
    }

    const content = () => {
        if (location === undefined && filters === undefined && spyLaunchSettings === undefined){
            return (
                <>
                    <span className={styles.SearchButton__IconContainer}>
                    <SearchIcon2
                        className={styles.SearchButton__Icon}
                    />
                    </span>
                    <span className={styles.SearchButton__CaptionContainer}>
                        <span className={styles.SearchButton__Caption}>{caption ? caption : `Search competitors`}</span>
                    </span>
                </>          
            )
        }
        
        return (
            <>
                <span className={styles.LocationButton__LocationCaptionContainer}>
                    <span className={styles.LocationButton__LocationCaption}>
                          {location?.name || 'Select Location'}
                    </span>                      
                </span>   
                <span className={styles.LocationButton__EndContainer}>
                    <span className={styles.LocationButton__SpyLaunchSettingsContainer }>
                        <span className={styles.LocationButton__SpyLaunchSettings}>
                            {spyLaunchSettingsToString(spyLaunchSettings)}
                        </span>
                    </span>
                    <span className={styles.LocationButton__FiltersContainer}>
                        <span className={styles.LocationButton__Filters}>
                            {filtersToString(filters)}
                        </span>
                    </span>
                </span>
            </>
        )
    }

    return (
        <>
            <button 
                className={styles.LocationButton}
                ref={ref}
                onClick={handleButtonClick}
            >
                {
                    content()
                }
            </button>
        </>
    )


}